import { render, staticRenderFns } from "./TextPage.vue?vue&type=template&id=cacdd5e0&scoped=true&"
import script from "./TextPage.vue?vue&type=script&lang=js&"
export * from "./TextPage.vue?vue&type=script&lang=js&"
import style0 from "./TextPage.vue?vue&type=style&index=0&id=cacdd5e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cacdd5e0",
  null
  
)

export default component.exports